/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Custom_DomainInputs */

const en_add_custom_domain = /** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Custom Domain`)
};

const id_add_custom_domain = /** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah Domain Kustom`)
};

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const es_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const fr_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const de_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const ja_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const zh_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const ar_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const it_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const ru_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const pt_add_custom_domain = en_add_custom_domain;

/** @type {(inputs: Add_Custom_DomainInputs) => LocalizedString} */
const ko_add_custom_domain = en_add_custom_domain;

/**
* | output |
* | --- |
* | "Add Custom Domain" |
*
* @param {Add_Custom_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_custom_domain = /** @type {((inputs?: Add_Custom_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Custom_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_custom_domain(inputs)
	if (locale === "es") return es_add_custom_domain(inputs)
	if (locale === "fr") return fr_add_custom_domain(inputs)
	if (locale === "de") return de_add_custom_domain(inputs)
	if (locale === "ja") return ja_add_custom_domain(inputs)
	if (locale === "zh") return zh_add_custom_domain(inputs)
	if (locale === "ar") return ar_add_custom_domain(inputs)
	if (locale === "id") return id_add_custom_domain(inputs)
	if (locale === "it") return it_add_custom_domain(inputs)
	if (locale === "ru") return ru_add_custom_domain(inputs)
	if (locale === "pt") return pt_add_custom_domain(inputs)
	return ko_add_custom_domain(inputs)
});